export default {"src":"/_next/static/media/generic-thumbnail-file.b0cda4ee.svg","height":81,"width":61,"blurWidth":0,"blurHeight":0};